<template>
  <div class="top-main">
    <div class="top-main-title-content">
      <div class="top-main-title">{{ formWorkTitle }}</div>
      <div class="top-main-card">
        <div class="top-main-item">
          <div class="top-main-item-title">住宅<br />用地</div>
          <div class="top-main-item-main-content">
            <div class="top-main-item-name">数量</div>
            <div class="top-main-item-num-content">
              <span class="top-main-item-num">{{
                residential.totalQuantity
              }}</span>
              <span class="top-main-item-unit">个</span>
            </div>
          </div>
          <div class="top-main-item-main-content">
            <div class="top-main-item-name">面积</div>
            <div class="top-main-item-num-content">
              <span class="top-main-item-num">{{
                parseFloat(Number(residential.grossArea.toFixed(2)))
              }}</span>
              <span class="top-main-item-unit">亩</span>
            </div>
          </div>
        </div>
        <div class="homeLine"></div>
        <div class="top-main-item">
          <div class="top-main-item-title">商服<br />用地</div>
          <div class="top-main-item-main-content">
            <div class="top-main-item-name">数量</div>
            <div class="top-main-item-num-content">
              <span class="top-main-item-num">{{
                commercial.totalQuantity
              }}</span>
              <span class="top-main-item-unit">个</span>
            </div>
          </div>
          <div class="top-main-item-main-content">
            <div class="top-main-item-name">面积</div>
            <div class="top-main-item-num-content">
              <span class="top-main-item-num">{{
                parseFloat(Number(commercial.grossArea.toFixed(2)))
              }}</span>
              <span class="top-main-item-unit">亩</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="top-main-notice">
        <div class="top-main-notice-content">
          <marquee-wrap
            :text="text"
            width="80%"
            color="#ffffff"
            contSize="18px"
          ></marquee-wrap>
          <div class="button-detail">查看详情</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import marqueeWrap from "@/components/formWorkOne/marqueeWrap.vue";
export default {
  name: "topMain",

  components: {
    marqueeWrap,
  },
  props: ["listArea", "formWorkTitle"],
  data() {
    return {
      text: "曲靖市人民政府办公室关于印发曲靖中心城市储备土地管护办法的通知1234567890",
      // 合并的数据
      arrParcel: [],
      // 总数量
      totalQuantity: 0,
      // 总面积
      grossArea: 0,
      // 住宅用地
      residential: {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      },
      // 工矿仓储用地
      keepGrain: {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      },
      // 商服用地
      commercial: {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      },
    };
  },
  watch: {
    listArea: {
      handler(newVal) {
        if (!!newVal) {
          // 合并地块分类
          this.parcelMerge(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 合并地块分类
    parcelMerge(newVal) {
      this.reset();
      newVal.forEach((item) => {
        if (!!item.dynamicTags && item.dynamicTags.length > 0) {
          item.dynamicTags.forEach((dynamicItem) => {
            if (!!dynamicItem.checkList && dynamicItem.checkList.length > 0) {
              dynamicItem.checkList.forEach((chechItem) => {
                this.arrParcel.push(chechItem);
              });
            }
          });
        }
        if (!!item.checkList && item.checkList.length > 0) {
          item.checkList.forEach((checkItem) => {
            this.arrParcel.push(checkItem);
          });
        }
      });
      // 统计
      this.amount();
    },
    // 筛选数据
    amount() {
      if (this.arrParcel.length > 0) {
        // 总数量
        this.totalQuantity = this.arrParcel.length;
        this.arrParcel.forEach((item) => {
          // 总面积
          this.grossArea += item.area;
          // 住宅用地
          if (item.type === "7") {
            this.residential.totalQuantity += 1;
            this.residential.grossArea += item.area;
          }
          // 工矿仓储用地
          if (item.type === "6") {
            this.keepGrain.totalQuantity += 1;
            this.keepGrain.grossArea += item.area;
          }
          // 商服用地
          if (item.type === "5") {
            this.commercial.totalQuantity += 1;
            this.commercial.grossArea += item.area;
          }
        });
      }
    },
    // 重置为空啊
    reset() {
      this.arrParcel = [];
      this.totalQuantity = 0;
      this.grossArea = 0;
      this.residential = {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      };
      this.keepGrain = {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      };
      this.commercial = {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      };
    },
  },
};
</script>

<style scoped>
.top-main {
  width: 100%;
}
.top-main-title-content {
  height: 390px;
  /*background-image: linear-gradient(160deg, rgba(63,77,201,.8), rgba(102,180,213,.4));*/
  position: relative;
  background-image: url("~@/assets/promotion/titleImg02.png");
  background-size: 100% 100%;
}
.top-main-title {
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 4px;
  font-style: italic;
  padding-top: 80px;
  box-sizing: border-box;
}
.top-main-card {
  background: #ffffff;
  height: 120px;
  width: 60%;
  margin: auto;
  position: absolute;
  bottom: 30px;
  left: 20%;
  box-shadow: inset 0 0 5px rgb(63 77 201 / 10%), 0 0 4px rgb(140 141 140 / 60%);
  /* border-top-left-radius: 4px;
  border-top-right-radius: 4px; */
  border-radius: 4px;
}
.top-main-notice {
  background: linear-gradient(90deg, #fd644f, #f58535, #f18e27);
  height: 60px;
  width: 62%;
  margin: auto;
  position: absolute;
  bottom: -25px;
  left: 19%;
  border-radius: 4px;
}
.top-main-notice-content {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 30px;
  justify-content: space-between;
  text-align: center;
}
.top-main-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top-main-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 80px;
  box-sizing: border-box;
  width: 50%;
  height: 100%;
}
.top-main-item-title {
  font-weight: bold;
}
.top-main-item-name {
  color: #968f8d;
  margin-bottom: 10px;
}
.top-main-item-num {
  font-size: 24px;
  font-weight: bold;
  color: #ff3a1e;
}
.top-main-item-unit {
  font-size: 14px;
  color: #ff3a1e;
  margin-left: 10px;
}
.homeLine {
  width: 1px;
  height: 80px;
  background: linear-gradient(
    244deg,
    rgba(182, 174, 172, 0) 0%,
    rgba(182, 174, 172, 1) 50%,
    rgba(182, 174, 172, 0) 100%
  );
}
.button-detail {
  width: 250px;
  height: 40px;
  background: red;
  color: #333333;
  line-height: 40px;
  background: linear-gradient(90deg, #fbb9a1, #ffe8cc);
  border-radius: 4px;
  cursor: pointer;
}
</style>